import { Stack, Typography, IconButton } from '@mui/material'
import { useEffect, useState } from 'react'

import { Input } from '@/components/ui/input'
import { TrashIcon } from '@/assets/icons/trash-icon'
import { type CardDraftBulkImport } from '@/components/BulkImportModal/store/bulk-import.store.types'

interface PromptDraftRowProps {
  cardId: string
  index: number
  isRepeat: boolean
  cardData: CardDraftBulkImport
  onDelete: (cardId: string) => void
  onSetValue: (key: keyof CardDraftBulkImport, value: string) => void
}

export function PromptDraftRow({ cardId, index, isRepeat, cardData, onDelete, onSetValue }: PromptDraftRowProps) {
  return (
    <Stack
      key={cardId}
      gap="10px"
      sx={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: '10px',
        alignItems: 'center',
      }}
    >
      <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between', gap: '10px', flex: '1' }}>
        <Stack
          sx={{
            flex: '1',
            padding: '6px',
            gap: '6px',
          }}
        >
          {isRepeat && index === 0 ? (
            <Typography fontWeight="medium" variant="sm">
              Target Text
            </Typography>
          ) : null}
          <InputRow
            defaultValue={cardData.prompt}
            onSetValue={value => {
              onSetValue('prompt', value)
            }}
          />
        </Stack>

        {isRepeat ? (
          <Stack
            sx={{
              flex: '1',
              padding: '6px',
              gap: '6px',
            }}
          >
            {index === 0 ? (
              <Typography fontWeight="medium" variant="sm">
                Translation
              </Typography>
            ) : null}
            <InputRow
              defaultValue={cardData.native_text}
              onSetValue={value => {
                onSetValue('native_text', value)
              }}
            />
          </Stack>
        ) : null}
      </Stack>

      <IconButton
        color="error"
        sx={{
          marginTop: index === 0 && isRepeat ? '20px' : '0px',
        }}
        onClick={() => {
          onDelete(cardId)
        }}
      >
        <TrashIcon color="#B42318" />
      </IconButton>
    </Stack>
  )
}

function InputRow({
  defaultValue,
  onSetValue,
}: {
  defaultValue: string

  onSetValue: (value: string) => void
}) {
  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <Input
      className="h-auto px-2 py-3 bg-white rounded-xl border-[#D0D5DD] !text-[14px]"
      defaultValue={defaultValue}
      onBlur={() => {
        onSetValue(value)
      }}
      onChange={e => {
        setValue(e.target.value)
      }}
    />
  )
}
